/*
 *   File : toast-container.js
 *   Author : https://evoqins.com
 *   Description : toast container component
 *   Integrations : 'react-toastify
 *   Version : 1.0.1
*/


// custom packages
import { ToastContainer } from "react-toastify";

// custom components
import Icon from '../Icon/icon';

// custom styles
import "react-toastify/dist/ReactToastify.css";


function Toast(props) {
    function CloseButton() {
        return (
            <Icon icon='close'
                size={40}
                className="position-absolute right-10px top-8px" />
        )
    }
    return (
        <ToastContainer
            position="bottom-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            closeButton={CloseButton}
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover={false}
        />
    );
}



export default Toast;